/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ text: NonNullable<unknown> }} Meeting_Prep_Actions_Done_ReopenInputs */



/**
* | output |
* | --- |
* | "Put back on the list: {text}" |
*
* @param {Meeting_Prep_Actions_Done_ReopenInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_prep_actions_done_reopen = /** @type {((inputs: Meeting_Prep_Actions_Done_ReopenInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Prep_Actions_Done_ReopenInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ (`Terug openzetten: ${i?.text}`)
	if (locale === "fr") return /** @type {LocalizedString} */ (`Rouvrir : ${i?.text}`)
	return /** @type {LocalizedString} */ (`Put back on the list: ${i?.text}`)
});